// VAF / PSI / CVRF tarih değişiklik onay akışı için sabitler.
// Backend'de JsonStringEnumConverter yok; enum'lar JSON'da sayı olarak gider/gelir.
// Kaynak: docs/FormDateChangeRequest_FE_Integration.md

export const FORM_TYPE = {
    VAF: 1,
    PSI: 2,
    CVRF: 3
};

export const DATE_FIELD = {
    VEHICLE_ACCEPT_DATE: 1, // VAF  - Araç Kabul Tarihi
    STOCK_IN_DATE: 2, // PSI  - Stok Giriş Tarihi
    INSPECTION_DATE: 3, // PSI  - Denetleme Tarihi
    VEHICLE_REGISTRATION: 4 // CVRF - İlk Tescil Tarihi
};

export const DATE_CHANGE_STATUS = {
    SENT_FOR_APPROVAL: 20,
    RETURN: 25,
    APPROVED: 30
};

export const DATE_FIELDS_BY_FORM_TYPE = {
    [FORM_TYPE.VAF]: [DATE_FIELD.VEHICLE_ACCEPT_DATE],
    [FORM_TYPE.PSI]: [DATE_FIELD.STOCK_IN_DATE, DATE_FIELD.INSPECTION_DATE],
    [FORM_TYPE.CVRF]: [DATE_FIELD.VEHICLE_REGISTRATION]
};

// Talebin açılabilmesi için ilgili formun kendi statüsünde olması gereken "kabul edilmiş" değer.
export const FORM_ACCEPTED_STATUS = {
    [FORM_TYPE.VAF]: 30, // VAFStatus.APPROVED
    [FORM_TYPE.PSI]: 10, // PSIStatusEnum.SENDTOKARSAN
    [FORM_TYPE.CVRF]: 30 // CVRFStatus.Approved
};

// i18n anahtarları için yardımcı eşleme (etiketler th() ile çözülmeli, burada sadece key adı tutulur).
export const DATE_FIELD_LABEL_KEYS = {
    [DATE_FIELD.VEHICLE_ACCEPT_DATE]: 'formDateChangeRequest.dateField.vehicleAcceptDate',
    [DATE_FIELD.STOCK_IN_DATE]: 'formDateChangeRequest.dateField.stockInDate',
    [DATE_FIELD.INSPECTION_DATE]: 'formDateChangeRequest.dateField.inspectionDate',
    [DATE_FIELD.VEHICLE_REGISTRATION]: 'formDateChangeRequest.dateField.vehicleRegistration'
};

export const FORM_TYPE_LABEL_KEYS = {
    [FORM_TYPE.VAF]: 'formDateChangeRequest.formType.vaf',
    [FORM_TYPE.PSI]: 'formDateChangeRequest.formType.psi',
    [FORM_TYPE.CVRF]: 'formDateChangeRequest.formType.cvrf'
};

export const DATE_CHANGE_STATUS_LABEL_KEYS = {
    [DATE_CHANGE_STATUS.SENT_FOR_APPROVAL]: 'formDateChangeRequest.status.sentForApproval',
    [DATE_CHANGE_STATUS.RETURN]: 'formDateChangeRequest.status.returned',
    [DATE_CHANGE_STATUS.APPROVED]: 'formDateChangeRequest.status.approved'
};
